import { useContext } from 'react'
import { BankDataFormContext } from 'refunds/context/BankDataFormContext/BankDataFormProvider'

export const useBankDataForm = () => useContext(BankDataFormContext)
